// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import AppstoreOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.3.1_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/AppstoreOutlined';
import UserOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.3.1_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/UserOutlined';
import NotificationOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.3.1_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/NotificationOutlined';
export default { AppstoreOutlined, UserOutlined, NotificationOutlined };
